// extracted by mini-css-extract-plugin
export default {"icon-button":"Regions_icon-button__9m2iA","card-body":"Regions_card-body__k6wxV","fa-lg":"Regions_fa-lg__mp2tZ","actionBtns":"Regions_actionBtns__Iwzxv"};